export const toTitleCase = (nameOfMda) => {
  const str = nameOfMda?.replace('↵', ' '); //remove the new line sign character...

  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const formatNumberAsCurrency = (
  number,
  lengthOfDecimal,
  lengthOfSections
) => {
  var re =
    '\\d(?=(\\d{' +
    (lengthOfSections || 3) +
    '})+' +
    (lengthOfDecimal > 0 ? '\\.' : '$') +
    ')';
  return number
    ?.toFixed(Math.max(0, ~~lengthOfDecimal))
    .replace(new RegExp(re, 'g'), '$&,');
};

export const getYearAndQuaterItems = (data) => {
  const items = data?.map((item) => item.year + ' ' + item.quarter);
  const uniqueItems = [...new Set(items)];
  return uniqueItems?.sort();
};

export const getUnit = (unit, value) => {
  switch (unit) {
    case 'Percentage':
      return value + '%';
    case 'Naira':
      return '₦' + value;
    case 'Dollar':
      return '$' + value;
    default:
      return value;
  }
};
